import React from 'react';

import Header from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentCalledSent from './ContentCalledSent';

const CalledSent = () => {
  return (
    <>
      <Header />
      <ContentCalledSent />
      <Bottom />
    </>
  );
};

export default CalledSent;
